module.exports = "<img src=\"/assets/images/gameboard/dynamicpanel/heart.png\" class=\"heart\" *ngIf=\"visible\"/>"